export default __webpack_public_path__ + "static/media/sellerRegistration.ea4e8e84.svg";